<template>
    <div class="bubble-settings">
        <div class="page-header">
            <div class="title">{{ $t("settings.bubbleSettings") }}</div>
            <div class="subtitle">{{ $t("settings.bubbleSettingsSubtitles") }}</div>
        </div>
        <section>
            <div class="fields">
                <FeatureItem
                    :title="$t('message.animations')"
                    icon="AnimationIcon"
                    v-model="preferredAnimation"
                    :description="$t('message.preferredAnimation')"
                    type="select"
                    :options="allAnimations.map((x) => ({ id: x, label: x }))"
                    :default-select-option-placeholder="$t('message.selectAnAnimation')"
                />

                <FeatureItem
                    :title="$t('message.chatPosition')"
                    icon="ChatLocation"
                    v-model="position"
                    :description="$t('message.chatPosition')"
                    type="select"
                    :options="chatPositionOptions"
                    :default-select-option-placeholder="$t('message.chatPositionSelect')"
                />

                <FeatureItem
                    v-model="autoHideBubble"
                    :description="$t('message.vtippyAutoHideBubble')"
                    :title="$t('message.autoHideBubble')"
                    icon="HideIcon"
                />

                <FeatureItem
                    v-model="hideBubble"
                    :description="$t('message.vtippyHideBubble')"
                    :title="$t('message.hideBubble')"
                    icon="NewHiddenIcon"
                />

                <FeatureItem
                    v-model="hideBubbleOnMobile"
                    :description="$t('message.vtippyHideBubbleOnMobile')"
                    :title="$t('message.hideBubbleOnMobile')"
                    icon="HideMobile"
                />

                <FeatureItem
                    v-model="brandVisible"
                    :description="$t('message.vtipyBrandVisibility')"
                    :title="$t('message.brandVisibility')"
                    icon="TickedIcon"
                />

                <div class="custom-field-slider">
                    <Modal2
                        v-if="isModal2Show"
                        id="bubble-icon-modal"
                        :title="$t('message.bubbleIcon')"
                        :show-footer="false"
                        @cancel="hideModal2"
                    >
                        <b-row>
                            <b-col class="bubbles-modal" md="12">
                                <label>{{ $t("message.preDefined") }}</label>
                                <b-row>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '1' }"
                                            src="/static/img/bubbles/btn1.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '1'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '2' }"
                                            src="/static/img/bubbles/btn2.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '2'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '3' }"
                                            src="/static/img/bubbles/btn3.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '3'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '4' }"
                                            src="/static/img/bubbles/btn4.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '4'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '5' }"
                                            src="/static/img/bubbles/btn5.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '5'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '6' }"
                                            src="/static/img/bubbles/btn6.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '6'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="3">
                                        <img
                                            :class="{ selected: preDefined === '7' }"
                                            src="/static/img/bubbles/btn7.svg"
                                            style="width: 100px; height: 100px; object-fit: contain"
                                            @click="preDefined = '7'"
                                        />
                                    </b-col>
                                    <b-col class="mt-3" md="12">
                                        <label>{{ $t("message.customIcon") }}</label>
                                        <div class="d-flex align-items-center">
                                            <md-button class="mr-3" @click="selectFile">
                                                <md-icon>upload</md-icon>
                                            </md-button>
                                            <img
                                                v-if="newIcon || (!!settings.bubble && !!settings.bubble.customIcon)"
                                                :class="{ selected: preDefined === '0' }"
                                                :src="bubbleIcon"
                                                alt="bubble"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = '0'"
                                            />
                                        </div>
                                    </b-col>
                                    <b-col md="12 mt-2">
                                        <b-button variant="primary" @click="selectBubble">
                                            <template>
                                                <span>{{ $t("message.ok") }}</span>
                                            </template>
                                        </b-button>
                                        <b-button @click="hideModal2">
                                            <template>{{ $t("message.cancel") }}</template>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </Modal2>
                </div>
                <a-card hoverable style="width: 500px">
                    <template #cover>
                        <div class="bubble-box">
                            <div
                                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                :content="$t('message.bubbleIcon')"
                                class="align-items-center text-align-center"
                            >
                                <img
                                    v-if="newIcon || (!!settings.bubble && preDefined === 0)"
                                    :src="bubbleIcon"
                                    alt="bubble"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                    @click="showModal2"
                                />
                                <div v-else @click="showModal2">
                                    <component
                                        v-for="i of $_.range(1, 8)"
                                        :is="`Bubble${i}`"
                                        :key="i"
                                        v-if="preDefined == i"
                                        class="bubble img-thumbnail img-select"
                                        :color="bubbleColor"
                                    />
                                </div>
                                <label style="font-weight: bold">{{ $t("message.bubbleIcon") }}</label>
                            </div>
                        </div>
                    </template>
                    <template #actions>
                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="offlineMode ? $t('message.viewOnTheSiteTippy') : $t('message.viewOnTheSiteTippy')"
                            class="custom-field-button"
                            style="padding: 5px"
                        >
                            <a
                                :href="visitorScreenUrl"
                                :style="{
                                    color: isDarkMode ? '#fff' : '#000',
                                }"
                                target="_blank"
                            >
                                <md-icon style="color: #369afe">preview</md-icon>
                                {{ $t("message.viewOnTheSite") }}
                            </a>
                        </div>
                        <div>
                            <a-button
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('message.inputPixelsOfChatBubble')"
                                class="btn btn primary override-margins"
                                @click="showModal"
                                >{{ $t("message.overrideMargins") }}
                            </a-button>
                            <a-modal
                                id="margin-inputs"
                                v-model="visible"
                                title=""
                                @cancel="afterModalClosed"
                                :footer="false"
                            >
                                <div class="container">
                                    <h6 class="pb-5">{{ $t("message.modalTitleIsMarginAsPixelInfo") }}</h6>
                                    <div v-if="isDisplayedMarginEdit || !!marginX || !!marginY">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label>{{ $t("message.inputPxOfXaxis") }}( PX )</label>
                                                <md-field
                                                    :class="{
                                                        'md-invalid':
                                                            errors.first($t('message.inputPxOfXaxis')) != null,
                                                    }"
                                                >
                                                    <md-input
                                                        v-model="marginX"
                                                        :name="$t('message.inputPxOfXaxis')"
                                                        autocomplete="off"
                                                        placeholder="px"
                                                        type="number"
                                                    ></md-input>
                                                </md-field>
                                            </div>
                                            <div class="col-sm-6">
                                                <label>{{ $t("message.inputPxOfYaxis") }}( PX )</label>
                                                <md-field
                                                    :class="{
                                                        'md-invalid':
                                                            errors.first($t('message.inputPxOfYaxis')) != null,
                                                    }"
                                                >
                                                    <md-input
                                                        v-model="marginY"
                                                        :name="$t('message.inputPxOfYaxis')"
                                                        autocomplete="off"
                                                        placeholder="px"
                                                        type="number"
                                                    ></md-input>
                                                </md-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="margin: 30px 0 30px 0; text-align: center">
                                        <a-button
                                            style="border: none; background: none; font-weight: 500; font-size: medium"
                                            @click="() => returnDefaultMarginSetting()"
                                            >{{ $t("message.returnDefaultMargins") }}
                                        </a-button>
                                    </div>
                                    <div>
                                        <div
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('message.vtippyOverrideMobileMargin')"
                                            class="custom-field-switch"
                                        >
                                            <label>{{ $t("message.overrideMobileMargin") }}</label>
                                            <md-switch
                                                v-model="overrideMobileMargin"
                                                class="md-primary ml-3"
                                                name="subject"
                                                required
                                            />
                                        </div>
                                        <div v-if="overrideMobileMargin">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <label>{{ $t("message.inputPxOfMobileXaxis") }}( PX )</label>
                                                    <md-field
                                                        :class="{
                                                            'md-invalid':
                                                                errors.first($t('message.inputPxOfMobileXaxis')) !=
                                                                null,
                                                        }"
                                                    >
                                                        <md-input
                                                            v-model="mobileMarginX"
                                                            :name="$t('message.inputPxOfMobileXaxis')"
                                                            autocomplete="off"
                                                            placeholder="px"
                                                            type="number"
                                                        ></md-input>
                                                    </md-field>
                                                </div>
                                                <div class="col-sm-6">
                                                    <label>{{ $t("message.inputPxOfMobileYaxis") }}( PX )</label>
                                                    <md-field
                                                        :class="{
                                                            'md-invalid':
                                                                errors.first($t('message.inputPxOfMobileYaxis')) !=
                                                                null,
                                                        }"
                                                    >
                                                        <md-input
                                                            v-model="mobileMarginY"
                                                            :name="$t('message.inputPxOfMobileYaxis')"
                                                            autocomplete="off"
                                                            placeholder="px"
                                                            type="number"
                                                        ></md-input>
                                                    </md-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="md-error">{{
                                        errors.first($t("message.inputPixelsOfChatBubble"))
                                    }}</span>
                                </div>
                            </a-modal>
                        </div>
                    </template>
                    <a-card-meta>
                        <template #avatar>
                            <div class="feature avatar">
                                <div class="left">
                                    <div class="texts">
                                        <div class="feature-title">
                                            <div
                                                v-if="preDefined !== 0"
                                                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                                :content="$t('message.bubbleColor')"
                                            >
                                                <label for="bubbleColor">{{ $t("message.bubbleColor") }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <a-input
                                        id="bubbleColor"
                                        v-model="bubbleColor"
                                        class="theme-color-input"
                                        type="color"
                                        style="width: 100px"
                                    />
                                </div>
                            </div>
                            <div
                                class="feature"
                                style="width: 450px; margin-bottom: 20px; display: flex; justify-content: center"
                                v-if="!!marginX || !!marginY"
                            >
                                <div class="texts">
                                    <div class="feature-title">
                                        <div
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            class="custom-field-switch d-flex flex-column"
                                            @click="showModalDirectly()"
                                        >
                                            <label>
                                                <p v-if="!!marginX" style="margin-bottom: 5px">
                                                    {{ $t("message.inputPxOfXaxis") }} : {{ marginX }}{{ marginText }}
                                                </p>
                                                <p v-if="!!marginY" style="margin-bottom: 0px">
                                                    {{ $t("message.inputPxOfYaxis") }} : {{ marginY }}{{ marginText }}
                                                </p>
                                            </label>
                                            <label v-if="overrideMobileMargin">
                                                <p v-if="!!mobileMarginX" style="margin-bottom: 5px">
                                                    {{ $t("message.inputPxOfMobileXaxis") }} : {{ mobileMarginX
                                                    }}{{ marginText }}
                                                </p>
                                                <p v-if="!!mobileMarginY" style="margin-bottom: 0px">
                                                    {{ $t("message.inputPxOfMobileYaxis") }} : {{ mobileMarginY
                                                    }}{{ marginText }}
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="feature">
                                <div class="left">
                                    <div class="texts">
                                        <div
                                            class="feature-title"
                                            style="font-size: 14px"
                                            :class="{
                                                'md-invalid': errors.first($t('message.inputHeightOfBubble')) != null,
                                            }"
                                        >
                                            {{ $t("message.inputHeightOfBubble") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <a-input
                                        v-model="heightOfBubble"
                                        :name="$t('message.inputHeightOfBubble')"
                                        autocomplete="off"
                                        placeholder="60"
                                        type="number"
                                        >px
                                    </a-input>
                                </div>
                            </div>
                            <div v-if="preDefined == 7">
                                <div class="feature" style="margin-top: 15px">
                                    <div class="left">
                                        <div class="text" @click="chatBubbleTextModal">
                                            <div class="feature-title">
                                                {{ $t("settings.chatBubbleTextSetting") }}
                                            </div>
                                            <div class="feature-description">
                                                {{ $t("settings.textOnChatBubble") }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right"></div>
                                    <a-modal
                                        id="margin-inputs"
                                        v-model="chatBubbleTextModalVisible"
                                        title=""
                                        @cancel="afterModalClosed"
                                        :footer="false"
                                    >
                                        <div class="container" @click.stop>
                                            <h5>
                                                {{ $t("settings.textToAppearOnChatBubble") }}
                                            </h5>
                                            <MultiContent ref="MultiContent" v-model="osrInitialObject"></MultiContent>
                                        </div>
                                    </a-modal>
                                </div>
                            </div>
                        </template>
                    </a-card-meta>
                </a-card>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import * as _ from "lodash";
import { getExtensionFromFileName } from "../../../../../utils/utils";
import { uploadAsset } from "../../../../../api/assetUpload";
import mimeTypes from "../../../../../components/util/mimeTypes";
import axios from "axios";
import FeatureItem from "../../../Settings/components/FeatureItem.vue";
import MultiContent from "../../../../../components/MultiContent.vue";
import { toObject } from "../../../../../utils/languageContent";
import Modal2 from "../../../../../components/common/Modal2.vue";

const log = log2("Settings/BubbleSettings");
export default {
    name: "BubbleSettings",
    components: {
        FeatureItem,
        MultiContent,
        Modal2,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isDisplayedMarginEdit: false,
            visible: false,
            chatBubbleTextModalVisible: false,
            newIcon: null,
            preDefined: _.get(this.settings, "bubble.preDefined", "1"),
            marginText: null,
            chatPositionOptions: [
                { id: "bottomLeft", label: this.$t("message.bottomLeftCorner") },
                { id: "left", label: this.$t("message.leftDocked") },
                { id: "bottomRight", label: this.$t("message.bottomRightCorner") },
                { id: "right", label: this.$t("message.rightDocked") },
            ],
            isModal2Show: false,
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            allAnimations: (state) => state.setting.allAnimations,
            bubbleIcon() {
                let { customIcon } = this.settings.bubble;
                if (this.newIcon || customIcon) {
                    let { path, _id, ext } = this.newIcon || customIcon;
                    return `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
                }
                return undefined;
            },
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) => state.site.plans,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        osrInitialObject: {
            get() {
                return !!this.systemLanguages
                    ? [
                          {
                              type: "text",
                              field: "content",
                              label: this.$t("message.message"),
                              placeholder: this.$t("message.message"),
                              data: this.systemLanguages.reduce((acc, lang) => {
                                  acc[lang] =
                                      this.settings.chatCustomizationSettings?.langContentOfBubbleMessage?.[lang] || "";
                                  return acc;
                              }, {}),
                              validation: "required",
                          },
                      ]
                    : [];
            },
            set(v) {
                this.langContentOfBubbleMessage = v[0].data;
            },
        },
        preferredAnimation: {
            get() {
                return _.get(this.settings.chatCustomizationSettings, "preferredAnimation");
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.preferredAnimation", value);
            },
        },
        position: {
            get() {
                return _.get(this.settings.chatCustomizationSettings, "position");
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.position", value);
            },
        },
        marginX: {
            get() {
                this.marginText = "px";
                return _.get(this.settings.chatCustomizationSettings, "margin.x");
            },
            set(value) {
                value =
                    !!value &&
                    !String(value)
                        .split("")
                        .map((x) => parseInt(x))
                        .includes(NaN)
                        ? value
                        : null;
                this.updateSettings("chatCustomizationSettings.margin.x", value);
            },
        },
        marginY: {
            get() {
                this.marginText = "px";
                return _.get(this.settings.chatCustomizationSettings, "margin.y");
            },
            set(value) {
                value =
                    !!value &&
                    !String(value)
                        .split("")
                        .map((x) => parseInt(x))
                        .includes(NaN)
                        ? value
                        : null;

                this.updateSettings("chatCustomizationSettings.margin.y", value);
            },
        },
        mobileMarginX: {
            get() {
                this.mobileMarginText = "px";
                return _.get(this.settings.chatCustomizationSettings, "mobileMargin.x");
            },
            set(value) {
                value =
                    !!value &&
                    !String(value)
                        .split("")
                        .map((x) => parseInt(x))
                        .includes(NaN)
                        ? value
                        : null;
                this.updateSettings("chatCustomizationSettings.mobileMargin.x", value);
            },
        },
        mobileMarginY: {
            get() {
                this.mobileMarginText = "px";
                return _.get(this.settings.chatCustomizationSettings, "mobileMargin.y");
            },
            set(value) {
                value =
                    !!value &&
                    !String(value)
                        .split("")
                        .map((x) => parseInt(x))
                        .includes(NaN)
                        ? value
                        : null;

                this.updateSettings("chatCustomizationSettings.mobileMargin.y", value);
            },
        },
        overrideMobileMargin: {
            get() {
                return _.get(this.settings, "chatCustomizationSettings.overrideMobileMargin", false) || false;
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.overrideMobileMargin", value);
            },
        },
        autoHideBubble: {
            get() {
                return this.settings.autoHideBubble;
            },
            set(value) {
                this.updateSettings("autoHideBubble", value);
            },
        },
        hideBubble: {
            // chat balonunu tamamen kapatma
            get() {
                return this.settings.hideBubble;
            },
            set(value) {
                this.updateSettings("hideBubble", value);
            },
        },
        hideBubbleOnMobile: {
            get() {
                return this.settings.hideBubbleOnMobile;
            },
            set(value) {
                this.updateSettings("hideBubbleOnMobile", value);
            },
        },
        offlineMode: {
            get() {
                return this.settings.offlineMode;
            },
            set(value) {
                this.updateSettings("offlineMode", value);
            },
        },
        brandVisible: {
            get() {
                return this.settings.brandVisible;
            },
            set(value) {
                if (value) {
                    this.setSettingValue({
                        setting: "brandVisible",
                        value: false,
                    });
                    this.$feature.beforeChangeBrandLogo(() => {
                        this.updateSettings("brandVisible", value);
                    });
                } else {
                    this.updateSettings("brandVisible", value);
                }
            },
        },
        showChatBubbleOnlyLoggedUser: {
            get() {
                return this.settings.showChatBubbleOnlyLoggedUser;
            },
            set(value) {
                this.updateSettings("showChatBubbleOnlyLoggedUser", value);
            },
        },
        bubbleColor: {
            get() {
                return (this.settings.bubble && this.settings.bubble.bubbleColor) || "#000000";
            },
            set(value) {
                this.updateSettings("bubble.bubbleColor", value);
            },
        },
        heightOfBubble: {
            get() {
                return (this.settings.bubble && this.settings.bubble.heightOfBubble) || "";
            },
            set(value) {
                value = value > 100 ? 100 : String(value).includes("-") ? 0 : value;
                this.updateSettings("bubble.heightOfBubble", value);
            },
        },
        langContentOfBubbleMessage: {
            get() {
                return this.settings.chatCustomizationSettings.langContentOfBubbleMessage;
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.langContentOfBubbleMessage", value);
            },
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        showModal2() {
            this.isModal2Show = true;
        },
        hideModal2() {
            this.isModal2Show = false;
        },

        chatBubbleTextModal() {
            this.chatBubbleTextModalVisible = true;
        },
        showModal() {
            this.visible = true;
            this.isDisplayedMarginEdit = true;
        },
        showModalDirectly() {
            this.isDisplayedMarginEdit = true;
            this.visible = true;
            log("showModalDirectly called");
        },
        afterModalClosed(e) {
            this.visible = false;
            this.isDisplayedMarginEdit = false;
            this.marginText = "px";
            log("afterModalClosed called");
        },
        returnDefaultMarginSetting() {
            log("returnDefaultMarginSetting called");
            this.marginX = null;
            this.marginY = null;
            this.mobileMarginX = null;
            this.mobileMarginY = null;
            this.visible = false;
            this.isDisplayedMarginEdit = false;
        },
        selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            let self = this;
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                if (this.beforeUpload(file)) {
                    const fileType = getExtensionFromFileName(file.name);
                    let path = `${this.site._id}/chatBubble/`;
                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                        size: file.size,
                        type: "other"
                    });
                    await axios({
                        method: data.method,
                        url: data.url,
                        data: file,
                    });
                    const newSettings = this.setSettingValue({
                        setting: "bubble.customIcon",
                        value: data.asset._id,
                    });
                    log("selectFile debugxxx");
                    if (newSettings.then) {
                        newSettings.then((x) => this.updateSettings(x));
                    } else {
                        this.updateSettings(newSettings);
                    }
                    self.preDefined = 0;
                    self.selectBubble();
                    self.newIcon = data.asset;
                } else {
                    log.warn("input is not suitable for send");
                    this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            };
            fileEl.click();
        },
        beforeUpload(file) {
            const testImgFile = /^image\/(jpg|jpeg|png)$/.test(file.type);
            const testSize = file.size <= 20 * 1024 * 1024;
            return testImgFile && testSize;
        },
        selectBubble() {
            const newSettings = this.setSettingValue({
                setting: "bubble.preDefined",
                value: this.preDefined,
            });
            log("selectBubble debugxxx");
            if (newSettings.then) {
                newSettings.then((x) => this.updateSettings(x));
            } else {
                this.updateSettings(newSettings);
            }
            /*this.$bvModal.hide("bubble-icon-modal");*/
            this.hideModal2();
        },
    },
    mounted() {
        this.getSettings().then(() => {
            this.isBusy = false;
            this.localOsrLabel = toObject(this.settings.osrLabels);
            if (!!this.settings.bubble) this.preDefined = parseInt(this.settings.bubble.preDefined);
            this.enabledFabs = _.get(this.settings.fab, "items", []);
            log("mounted", ...this.enabledFabs);
        });
        this.mountedTime = Date.now();
    },
    watch: {
        settings: {
            handler() {
                const newPreDefined = _.get(this.settings, "bubble.preDefined", "0");
                if (newPreDefined !== this.preDefined) {
                    this.preDefined = newPreDefined;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.bubble {
    &.img-thumbnail {
        width: 100px;
        height: 100px;
        object-fit: contain;
    }
}

.feature {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    background: var(--color-bg-neutral-default);
    max-width: 900px;

    .left {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-strong-default);
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }
}

.dark-mode .feature {
    background: #1e1e2d;

    .left {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: #fff;
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }
}

.dark-mode .ant-card-actions {
    background: #1e1e2d !important;
}

.errSpan {
    font-size: 8px;
    color: var(--color-bg-critical-default);
}

.right {
    display: flex !important;
    align-items: center !important;

    .ant-switch-checked {
        background-color: var(--color-bg-primary-default);
    }
}

.avatar {
    width: 450px;
    margin-bottom: 20px;
}

.text-align-center {
    text-align: center;
}

.bubble-box {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
</style>
